module.exports = __webpack_public_path__ + "static/img/onep.3fff2182.png";